// Libs
import React, { ReactElement } from 'react';
import { MenuItem, ListItemIcon, Icon } from 'ui-components';
// App
import styles from './account.module.scss';
import { CashJournalMenuItemProps } from './cash-journal-menu-item.props';
import { UnstyledLink } from '@/components/navigation';
import { SHOP_ADMIN_PAGES_URLS } from '@/fragments/shop-administration/shop-administration.constants';

const CashJournalMenuItem = (props: CashJournalMenuItemProps): ReactElement => {
  const { shopId, selected } = props;

  const cashJournalUrl = `${SHOP_ADMIN_PAGES_URLS['cash-journal']}?shp_id=${shopId}`;

  return (
    <UnstyledLink href={cashJournalUrl}>
      <MenuItem className={styles.menuItem} selected={selected}>
        <ListItemIcon>
          <Icon name="shield-check" />
        </ListItemIcon>
        Journal de caisse
      </MenuItem>
    </UnstyledLink>
  );
};

export default CashJournalMenuItem;
